import { render, staticRenderFns } from "./counterparties.vue?vue&type=template&id=680e47ec&scoped=true"
import script from "./counterparties.vue?vue&type=script&lang=js"
export * from "./counterparties.vue?vue&type=script&lang=js"
import style0 from "./counterparties.vue?vue&type=style&index=0&id=680e47ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e47ec",
  null
  
)

export default component.exports